import React, { FC, useEffect } from "react";

import { useSelector } from "react-redux";

import { getFetchStatus, getSearchAiSummaryText } from "../../../../store/searchAiSummary/selectors";
import GenAiSearchSummary from "../../GenAiSearchSummary";

import useAiSummaryController from "./useAiSummary.controller";
import styles from "./AiSummary.desktop.module.css";
import flights_web_sr_gen_ai_summary_v3_ddot from "../../../../utils/experiments/funnel/flights_web_sr_gen_ai_summary_v3_ddot";
import useProfiler from "../../../../hooks/useProfiler";

const AiSummaryDesktop: FC = () => {
  const { isAmerican } = useProfiler();
  const fetchStatus = useSelector(getFetchStatus);
  const summaryText = useSelector(getSearchAiSummaryText);

  useAiSummaryController(flights_web_sr_gen_ai_summary_v3_ddot.trackWithDefaultStage() ? "v2" : "v1");
  flights_web_sr_gen_ai_summary_v3_ddot.useTrackStages();

  useEffect(() => {
    fetchStatus === "success" && flights_web_sr_gen_ai_summary_v3_ddot.goals.success();
    fetchStatus === "failed" && flights_web_sr_gen_ai_summary_v3_ddot.goals.error();
  }, [fetchStatus]);

  if (isAmerican() && !flights_web_sr_gen_ai_summary_v3_ddot.trackWithDefaultStage()) {
    return null;
  }

  return (
    <GenAiSearchSummary
      variant={flights_web_sr_gen_ai_summary_v3_ddot.trackWithDefaultStage() ? "collapsed_text" : "card"}
      summaryText={summaryText || ""}
      className={styles.root}
      isLoading={fetchStatus === "loading"}
      isError={fetchStatus === "failed"}
      onCtaClick={() => {
        flights_web_sr_gen_ai_summary_v3_ddot.stages.ctaClicked();
        flights_web_sr_gen_ai_summary_v3_ddot.goals.ctaClick();
      }}
    />
  );
};

export default AiSummaryDesktop;
